import { useNavigate, useLocation, Outlet, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import AppointmentIcon from "../assets/icon/AppointmentIcon";
import ReferIcon from "../assets/icon/ReferIcon";
import HomeIcon from "../assets/icon/HomeIcon";
import StatsticIcon from "../assets/icon/StatsticIcon";
import CaretakerIcon from "../assets/icon/CaretakerIcon";
import ProfileIcon from "../assets/icon/ProfileIcon";
import ConIcon from "../assets/icon/ConIcon";
import CarePlanIcon from "../assets/icon/CareIcon";
import CommunicationIcon from "../assets/icon/CommunicationIcon";

export const UserLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isLoading } = useAuth();

  // Don't redirect while loading initial auth state
  if (isLoading) {
    return <div style={{ padding: 20 }}>Loading...</div>;
  }

  // Redirect to login if not authenticated
  if (!user || user.role !== "patient") {
    return <Navigate to="/patient-login" replace />;
  }

  // Get the current "section" from URL, e.g., 'appointment', 'patient', 'referral', 'noshow'
  // Assumes URL like /layout/appointment or /layout/noshow/123 etc.
  const currentPath = location.pathname.split("/")[2] || "dashboard";

  return (
    <div className="mainWrapper">
      <div className="navpanel">
        <button
          className={`navlink-tab ${currentPath === "patient-dashboard" ? "selected" : ""}`}
          onClick={() => navigate("/user-layout/patient-dashboard")}
          aria-label="Dashboard"
          style={{ background: 'none', border: 'none', padding: 0 }}
        >
          <div className={`icon ${currentPath === "patient-dashboard" ? "selected" : ""}`}>
            <HomeIcon
              width={15}
              height={15}
              color={currentPath === "patient-dashboard" ? "#ffffff" : "#009FF5"}
            />
          </div>
          <div className="navlink">Dashboard</div>
        </button>
        <button
          className={`navlink-tab ${currentPath === "patient-appointment" ? "selected" : ""}`}
          onClick={() => navigate("/user-layout/patient-appointment")}
          aria-label="My Appointments"
          style={{ background: 'none', border: 'none', padding: 0 }}
        >
          <div className={`icon ${currentPath === "patient-appointment" ? "selected" : ""}`}>
            <AppointmentIcon
              width={15}
              height={15}
              color={currentPath === "patient-appointment" ? "#ffffff" : "#009FF5"}
            />
          </div>
          <div className="navlink">My Appointments</div>
        </button>
        <button
          className={`navlink-tab ${currentPath === "my-health" ? "selected" : ""}`}
          onClick={() => navigate("/user-layout/my-health")}
          aria-label="My Health"
          style={{ background: 'none', border: 'none', padding: 0 }}
        >
          <div className={`icon ${currentPath === "my-health" ? "selected" : ""}`}>
            <StatsticIcon
              width={15}
              height={15}
              color={currentPath === "my-health" ? "#ffffff" : "#009FF5"}
            />
          </div>
          <div className="navlink">My Health</div>
        </button>

        <button
          className={`navlink-tab ${currentPath === "my-caretaker" ? "selected" : ""}`}
          onClick={() => navigate("/user-layout/my-caretaker")}
          aria-label="Caretakers"
          style={{ background: 'none', border: 'none', padding: 0 }}
        >
          <div className={`icon ${currentPath === "my-caretaker" ? "selected" : ""}`}>
            <CaretakerIcon
              width={15}
              height={15}
              color={currentPath === "my-caretaker" ? "#ffffff" : "#009FF5"}
            />
          </div>
          <div className="navlink">Caretakers</div>
        </button>


        <button
          className={`navlink-tab ${currentPath === "my-profile" ? "selected" : ""}`}
          onClick={() => navigate("/user-layout/my-profile")}
          aria-label="My Profile"
          style={{ background: 'none', border: 'none', padding: 0 }}
        >
          <div className={`icon ${currentPath === "my-profile" ? "selected" : ""}`}>
            <ProfileIcon
              width={15}
              height={15}
              color={currentPath === "my-profile" ? "#ffffff" : "#009FF5"}
            />
          </div>
          <div className="navlink">My Profile</div>
        </button>

        <button
          className={`navlink-tab ${currentPath === "my-concierges" ? "selected" : ""}`}
          onClick={() => navigate("/user-layout/my-concierges")}
          aria-label="My-Concierges"
          style={{ background: 'none', border: 'none', padding: 0 }}
        >
          <div className={`icon ${currentPath === "my-concierges" ? "selected" : ""}`}>
            <ConIcon
              width={15}
              height={15}
              color={currentPath === "my-concierges" ? "#ffffff" : "#009FF5"}
            />
          </div>
          <div className="navlink">My Concierges</div>
        </button>

        <button
          className={`navlink-tab ${currentPath === "my-communication" ? "selected" : ""}`}
          onClick={() => navigate("/user-layout/my-communication")}
          aria-label="Communication"
          style={{ background: 'none', border: 'none', padding: 0 }}
        >
          <div className={`icon ${currentPath === "my-communication" ? "selected" : ""}`}>
            <CommunicationIcon
              width={15}
              height={15}
              color={currentPath === "my-communication" ? "#ffffff" : "#009FF5"}
            />
          </div>
          <div className="navlink">Communication</div>
        </button>
        
        <button
          className={`navlink-tab ${currentPath === "patient-referal" ? "selected" : ""}`}
          onClick={() => navigate("/user-layout/patient-referral")}
          aria-label="Referral"
          style={{ background: 'none', border: 'none', padding: 0 }}
        >
          <div className={`icon ${currentPath === "patient-referal" ? "selected" : ""}`}>
            <ReferIcon
              width={15}
              height={15}
              color={currentPath === "patient-referal" ? "#ffffff" : "#009FF5"}
            />
          </div>
          <div className="navlink">Referral</div>
        </button>

        <button
          className={`navlink-tab ${currentPath === "care-plan" ? "selected" : ""}`}
          onClick={() => navigate("/user-layout/care-plan")}
          aria-label="Care-Plan"
          style={{ background: 'none', border: 'none', padding: 0 }}
        >
          <div className={`icon ${currentPath === "care-plan" ? "selected" : ""}`}>
            <CarePlanIcon
              width={15}
              height={15}
              color={currentPath === "care-plan" ? "#ffffff" : "#009FF5"}
            />
          </div>
          <div className="navlink">Care Plan</div>
        </button>

        <button
          className={`navlink-tab ${currentPath === "patient-discharge" ? "selected" : ""}`}
          onClick={() => navigate("/user-layout/patient-discharge")}
          aria-label="Discharge"
          style={{ background: 'none', border: 'none', padding: 0 }}
        >
          <div className={`icon ${currentPath === "patient-discharge" ? "selected" : ""}`}>
            <ReferIcon
              width={15}
              height={15}
              color={currentPath === "patient-discharge" ? "#ffffff" : "#009FF5"}
            />
          </div>
          <div className="navlink">Discharge</div>
        </button>

        {/* <div
          className={`navlink-tab ${currentPath === "patient" ? "selected" : ""}`}
          onClick={() => navigate("/layout/patient")}
        >
          <div className={`icon ${currentPath === "patient" ? "selected" : ""}`}>
            <PatientIcon
              width={15}
              height={15}
              color={currentPath === "patient" ? "#ffffff" : "#009FF5"}
            />
          </div>
          <div className="navlink">Patients</div>
        </div>

        <div
          className={`navlink-tab ${currentPath === "referral" ? "selected" : ""}`}
          onClick={() => navigate("/layout/referral")}
        >
          <div className={`icon ${currentPath === "referral" ? "selected" : ""}`}>
            <ReferIcon
              width={15}
              height={15}
              color={currentPath === "referral" ? "#ffffff" : "#009FF5"}
            />
          </div>
          <div className="navlink">Referrals</div>
        </div>

        <div
          className={`navlink-tab ${currentPath === "noshow" ? "selected" : ""}`}
          onClick={() => navigate("/layout/noshow")}
        >
          <div className={`icon ${currentPath === "noshow" ? "selected" : ""}`}>
            <NoshowIcon
              width={15}
              height={15}
              color={currentPath === "noshow" ? "#ffffff" : "#009FF5"}
            />
          </div>
          <div className="navlink">No Show</div>
        </div> */}
      </div>

      <div className="mainContainer">
        {/* Outlet will render nested routes like /layout/noshow, /layout/patient etc */}
        <Outlet />
      </div>
    </div>
  );
};
